import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.DELETE_COUPON_REQUEST:
      return {
        data: null,
        isProgress: true,
      };
    case homeConstants.DELETE_COUPON_SUCCESS:
      return {
        data: action.response,
        isProgress: false,
      };
    case homeConstants.DELETE_COUPON_FAILURE:
      return {
        data: null,
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_DELETE_COUPON_INFO:
      return {
        data: null,
        isProgress: false,
      };
    default:
      return state;
  }
}
